var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-slider',{attrs:{"showLabel":_vm.showLabel,"label":_vm.label,"required":_vm.required,"size":_vm.size,"step":_vm.step},on:{"input":_vm.percentToDates},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }